import { useLocation } from "react-router-dom";

import { useMenuCurrentItem } from "@/components/menu";
import { useMenus } from "@/providers";

import { IToolbarPageTitleProps } from "./types";

const ToolbarPageTitle = ({ text, id }: IToolbarPageTitleProps) => {
  const { pathname } = useLocation();
  const { getMenuConfig } = useMenus();
  const menuConfig = getMenuConfig("primary");
  const menuItem = useMenuCurrentItem(pathname, menuConfig);

  return (
    <h1
      id={id}
      className="text-xl font-medium leading-none text-gray-900"
      tabIndex={id ? -1 : undefined}
    >
      {text ?? menuItem?.title}
    </h1>
  );
};

export { ToolbarPageTitle };
